<template>
    <div class="grado-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="750" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="campusForm" v-model="validGrado">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="gradoItem.nombre"
                                                label="Nombre*"
                                                :counter="255"
                                                :rules="nombredRules"
                                                :error-messages="nombreErrors"
                                                @blur="nombreErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="gradoItem.nivel_educativo"
                                                label="Nivel educativo*"
                                                :counter="100"
                                                :rules="nivel_educativoRules"
                                                :error-messages="nivel_educativoRErrors"
                                                @blur="nivel_educativoRErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="gradoItem.campus_id"
                                                :items="CAMPUS"
                                                label="Campus*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="campus_idRules"
                                                :error-messages="campus_idErrors"
                                                @blur="campus_idErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-select
                                                v-model="gradoItem.seccion_id"
                                                :items="SECCIONES.filter(el => el.campus_id === gradoItem.campus_id)"
                                                label="Sección*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="seccion_idRules"
                                                :error-messages="seccion_idErrors"
                                                @blur="seccion_idErrors = []"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="gradoItem.secuencia"
                                                label="Secuencia*"
                                                type="number"
                                                :rules="secuenciaRules"
                                                :error-messages="secuenciaRErrors"
                                                @blur="secuenciaRErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="gradoItem.aut_rvoe"
                                                label="Aut. RVOE*"
                                                type="number"
                                                :rules="aut_rvoeRules"
                                                :error-messages="aut_rvoeErrors"
                                                @blur="aut_rvoeRErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field
                                                v-model="gradoItem.curso"
                                                label="Curso"
                                                :counter="100"
                                                :error-messages="cursoErrors"
                                                @blur="cursoErrors = []"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <small class="ml-2">(*) indica campos requeridos</small>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <tipo-ciclo-tarifa-form
            v-if="showTipoCicloTarifaForm"
            form-title="Nueva tarifa"
            :initial-item="null"
            @formCanceled="showTipoCicloTarifaForm = false"
        ></tipo-ciclo-tarifa-form>
    </div>
</template>

<script>
/* eslint-disable */
	import { mapGetters } from "vuex"
	const TipoCicloTarifaForm = () => import("@/components/cobranza/nomencladores/grado-form/tipo-ciclo-tarifa-form")

    export default {
		components: { TipoCicloTarifaForm },
		props: {
			formTitle: String,
			initialItem: Object
		},
		data () {
			return {
				loading: false,
				validGrado: false,
				gradoItem: {
					nombre: '',
					campus_id: '',
					seccion_id: '',
                    curso: '',
                    nivel_educativo: '',
                    secuencia: '',
                    aut_rvoe: '',
				},
                
                //formularios de nomencladores
                showTipoCicloTarifaForm: false,
                
				nombredRules: [
					v => !!v || 'Debe proporcionar un nombre',
				],
				nombreErrors: [],
				campus_idRules: [
					v => !!v || 'Debe proporcionar un campus'
				],
				campus_idErrors: [],
				seccion_idRules: [
					v => !!v || 'Debe proporcionar una sección'
				],
				seccion_idErrors: [],
				tarifa_idRules: [
					v => !!v || 'Debe proporcionar una tarifa'
				],
				tarifa_idErrors: [],
				nivel_educativoRules: [
					v => !!v || 'Debe proporcionar un nivel educativo',
					v => v.length <= 100 || 'Debe contener menos de 100 caracteres',
				],
				nivel_educativoRErrors: [],
				secuenciaRules: [
					v => !!v || 'Debe proporcionar una secuencia'
				],
				secuenciaRErrors: [],
				aut_rvoeRules: [
					v => !!v || 'Debe proporcionar el Aut. RVOE'
				],
				aut_rvoeErrors: [],
				cursoErrors: [],
			}
		},
		computed: {
            ...mapGetters(['CAMPUS', 'SECCIONES', 'CICLO', 'TARIFAS']),

			isNewRecord() {
				return this.initialItem === null
			},

			showForm: {
				get: function() {
					return true
				},
				set: function () {
					return this.cancelForm()
				}
			},

			disableSaveButton() {
				return this.loading || (!this.validGrado)
			}
		},

		methods:{
			saveForm() {
				this.loading = true
				this.$refs.campusForm.validate()
				if (this.validGrado) {
					let grado = {}
					grado.nombre = this.gradoItem.nombre
					grado.seccion_id = this.gradoItem.seccion_id
					grado.curso = this.gradoItem.curso
					grado.nivel_educativo = this.gradoItem.nivel_educativo
					grado.secuencia = this.gradoItem.secuencia
					grado.aut_rvoe = this.gradoItem.aut_rvoe

					if (!this.isNewRecord) {
						grado.id = this.initialItem.id
					}
					this.$store.dispatch(this.isNewRecord ? "ADD_GRADO" : "UPDATE_GRADO", grado).then(
						result => {
							if (!result) {//no hay coneccion con el servidor
								this.loading = false
							}
							if (result === null || result.status === 404 || result.status === 500) {
								//cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
								this.$emit("formCanceled")
							} else {
								// El backend devolvió error de validación, pasando los errores a los campos correspondientes
								let { data, status } = result
								if (status === 422) {
									data.forEach(error => {
										if (error.field === "nombre") {
											this.nombreErrors.push(error.message)
										}
										if (error.field === "seccion_id") {
											this.seccion_idErrors.push(error.message)
										}
										if (error.field === "nivel_educativo") {
											this.nivel_educativoRErrors.push(error.message)
										}
										if (error.field === "secuencia") {
											this.secuenciaRErrors.push(error.message)
										}
										if (error.field === "aut_rvoe") {
											this.aut_rvoeRErrors.push(error.message)
										}
										if (error.field === "curso") {
											this.cursoErrors.push(error.message)
										}
									})
								}
							}
							this.loading = false
						}
					)
				} else {
					this.loading = false
				}
			},
			cancelForm() {
				this.$emit("formCanceled")
			},

			customFilter (item, queryText, itemText) {
				const textTarifa = item.nombre.toLowerCase()
				const textCiclo = this.CICLO.filter(el => el.id === item.tipo_ciclo_id)[0].nombre.toLowerCase()
				const searchText = queryText.toLowerCase()

				return textTarifa.indexOf(searchText) > -1 ||
					textCiclo.indexOf(searchText) > -1
			},
		},

		mounted() {
            this.$store.dispatch("LOAD_ALL_CAMPUS")
			this.$store.dispatch("LOAD_ALL_SECCIONES")
			this.$store.dispatch("LOAD_ALL_CICLO")
			this.$store.dispatch("LOAD_ALL_TARIFAS")

			if (this.initialItem !== null) {
				// Cargando información del elemento a actualizar
                this.gradoItem.nombre = this.initialItem.nombre
                if (this.initialItem.campus) {
                    this.gradoItem.campus_id = this.initialItem.campus.id
                }
                this.gradoItem.seccion_id = this.initialItem.seccion_id
                this.gradoItem.curso = this.initialItem.curso
                this.gradoItem.nivel_educativo = this.initialItem.nivel_educativo
                this.gradoItem.secuencia = this.initialItem.secuencia
                this.gradoItem.aut_rvoe = this.initialItem.aut_rvoe
			}
		},
	};
</script>
